import {
  BenefitsListT,
  ReebeloCareContentT,
  WarrantyBenefitsListT,
} from './types';
import clickIcon from '@/public/icons/product/reebelocare/click.svg';
import globeIcon from '@/public/icons/product/reebelocare/globe.svg';
import shieldIcon from '@/public/icons/product/reebelocare/shield.svg';
import moneyIcon from '@/public/icons/product/reebelocare/money.svg';
import storeIcon from '@/public/icons/product/reebelocare/store.svg';
import replaceIcon from '@/public/icons/product/reebelocare/replace.svg';
import checkIcon from '@/public/icons/product/reebelocare/check.svg';
import supportIcon from '@/public/icons/product/reebelocare/support.svg';
import clockIcon from '@/public/icons/product/reebelocare/clock.svg';
import calendarIcon from '@/public/icons/product/reebelocare/calendar.svg';

export const reebeloCareTitles: ReebeloCareContentT = {
  'reebelo-au': 'ReebeloCare: 24-Month Extended Warranty & Any Reason Care',
  'reebelo-ca': '24-Months Physical & Liquid Damage Protection by Allstate',
  default: '2-Year Accident & Breakdown Protection',
};

export const reebeloCareSpecs: ReebeloCareContentT = {
  'reebelo-ca':
    'Full coverage against malfunction, physical & liquid damage | 24-HR online claims service<br /><div class="text-gray-700/60"><a href="https://edge.reebelo.com/files/sqt/PDS-CA.pdf" class="underline hover:text-gray-700" target="_blank" rel="noopener noreferrer">Product Summary</a> - <a href="https://edge.reebelo.com/files/sqt/PDS-FRCA.pdf" class="underline hover:text-gray-700" target="_blank" rel="noopener noreferrer">Sommaire du Produit</a></div>',
  'reebelo-au':
    'Product servicing or replacement for any reason. Including screen, back glass and battery. <a href="https://edge.reebelo.com/files/sqt/01-PDS.pdf" class="text-blue-500 underline" target="_blank" rel="noopener noreferrer">Service fees apply</a>',
  default:
    'Full coverage against malfunction, physical & liquid damage | 24-hr claim approval | Walk-in repair by certified technicians',
};

export const warrantySlideOverTitles: ReebeloCareContentT = {
  'reebelo-au': 'ReebeloCare: Worldwide, Any Reason Service for 24-Months',
  'reebelo-ca': 'Add our comprehensive protection plan by Allstate',
  default: 'Safeguard your device with ReebeloCare',
};

export const warrantySliderOverAcceptCta: ReebeloCareContentT = {
  'reebelo-au': 'Add ReebeloCare',
  default: 'Add 24-month plan',
};

export const benefitsList: BenefitsListT = {
  'reebelo-au': [
    {
      content: 'Request product servicing or replacement, for any reason.',
      icon: replaceIcon,
    },
    {
      content:
        'On-demand support, even if your product is faulty, damaged or broken.',
      icon: supportIcon,
    },
    {
      content:
        '24/7 online self-service available or call us in AU business hours.',
      icon: clockIcon,
    },
    {
      content: 'Your choice of walk-in, mail-in, or come-to-you service.',
      icon: storeIcon,
    },
    {
      content: "Services available even when you're overseas.",
      icon: globeIcon,
    },
    {
      content: 'Make unlimited service requests.',
      icon: clickIcon,
    },
    {
      content:
        "Reebelo's extended warranty period increases to 24-months when you purchase ReebeloCare.",
      icon: calendarIcon,
    },
    {
      content:
        '<span>All service requests are subject to the applicable <a href="https://edge.reebelo.com/files/sqt/01-PDS.pdf" class="text-blue-500 underline" target="_blank" rel="noopener noreferrer">service fees</a></span>.',
      icon: checkIcon,
    },
  ],
  'reebelo-ca': [
    {
      content: 'Covers breakdown, physical and liquid damage.',
      icon: replaceIcon,
    },
    {
      content: 'Screen, back glass & battery replacement included.',
      icon: shieldIcon,
    },
    {
      content: 'Fast Repairs or Replacements.',
      icon: clockIcon,
    },
    {
      content:
        '24/7 online self-service available or call us in business hours.',
      icon: supportIcon,
    },
  ],
  default: [
    {
      content:
        'Extended warranty coverage for defects, malfunctions and breakdowns for up to 24 months.',
      icon: shieldIcon,
    },
    {
      content:
        'Covers extensive accidental damage including cracked screens & spills.',
      icon: moneyIcon,
    },
    {
      content:
        'Hassle-free claims, same day service, mail-in or walk-in at 1000+ repair centers.',
      icon: storeIcon,
    },
    {
      content:
        "We'll either replace your device or provide you with the funds to buy another if your device can't be repaired.",
      icon: replaceIcon,
    },
    {
      content: 'Open a claim even when overseas with worldwide protection.',
      icon: globeIcon,
    },
    {
      content: 'File claims via our online claims portal, at your convenience.',
      icon: clickIcon,
    },
  ],
};

export const warrantyUpsellTitles: ReebeloCareContentT = {
  'reebelo-au': 'Add ReebeloCare: 24-Month Extended Warranty & Any Reason Care',
  'reebelo-ca': 'Add our comprehensive protection plan by Allstate',
  default: 'Add ReebeloCare now',
};

export const warrantyUpsellContents: ReebeloCareContentT = {
  'reebelo-au':
    'Product servicing or replacement for any reason even if your product is faulty, damaged or broken. Includes screen, back glass and battery replacement services',
  default:
    'Giving you 2-Years worldwide protection against accidental damage and breakdown',
};

export const warrantyUpsellRejectCta: ReebeloCareContentT = {
  'reebelo-au': 'Continue Without ReebeloCare',
  default: 'Continue without ReebeloCare',
};

export const warrantyUpsellAcceptCta: ReebeloCareContentT = {
  'reebelo-au': 'Add ReebeloCare',
  default: 'Protect me with ReebeloCare',
};

export const warrantyDisclaimers: ReebeloCareContentT = {
  'reebelo-us':
    'A $50 service fee will apply once your claim has been approved.',
  'reebelo-ca': 'A service fee will apply once your claim has been approved',
  default: 'A service fee will apply once your claim has been approved.',
};

export const multipleWarrantyUpsellTitles: ReebeloCareContentT = {
  'reebelo-au': 'Add ReebeloCare plan by Squaretrade',
  'reebelo-ca': 'Add our comprehensive protection plan by Allstate',
  default: 'Add our worldwide accidental damage protection plan',
};

export const warrantyBenefitsList: WarrantyBenefitsListT = {
  'reebelo-au': [
    {
      label: '2 years comprehensive worldwide service.',
      showInMobile: true,
    },
    {
      label: 'Any reason for parts replacement or device exchange.',
      showInMobile: true,
    },
    {
      label: 'Screen, back glass & battery replacement included.',
      showInMobile: true,
    },
    {
      label: 'Easy online service request & fast over-the-phone support.',
      showInMobile: true,
    },
  ],
  'reebelo-us': [
    {
      label: 'Extended warranty for defects and breakdowns.',
      showInMobile: true,
    },
    {
      label: 'Covers accidental damage like cracked screens and spills.',
      showInMobile: true,
    },
    {
      label: 'Same-day service, mail-in or walk-in at 1000+ repair centers.',
      showInMobile: true,
    },
    {
      label: "If we can't repair it, we'll replace it or refund you.",
      showInMobile: false,
    },
  ],
  'reebelo-ca': [
    {
      label: 'Covers breakdown, physical and liquid damage.',
      showInMobile: true,
    },
    {
      label: 'Screen, back glass & battery replacement included.',
      showInMobile: true,
    },
    {
      label: 'Fast Repairs or Replacements.',
      showInMobile: true,
    },
    {
      label:
        'Fast and easy service with online claims + over-the-phone support.',
      showInMobile: false,
    },
  ],
  default: [
    {
      label: 'Extended warranty for defects and breakdowns.',
      showInMobile: true,
    },
    {
      label: 'Covers accidental damage like cracked screens and spills.',
      showInMobile: true,
    },
    {
      label: 'Same-day service, mail-in or walk-in at 1000+ repair centers.',
      showInMobile: true,
    },
    {
      label: "If we can't repair it, we'll replace it or refund you.",
      showInMobile: false,
    },
  ],
};
